export default class extends Controller {
  static targets = ['toggleLink', 'blockedListItem'];

  connect() {
    this.showingBlockedItems = true;
  }

  toggleBlockedTasks(event) {
    event && event.preventDefault();
    this.showingBlockedItems = !this.showingBlockedItems;
    this.blockedListItemTargets.forEach(li => li.style.display = this.showingBlockedItems ? 'list-item' : 'none');
  }

  //
  // GETTERS AND SETTERS
  //

  get showingBlockedItems() {
    return ['true', '1', true].indexOf(this.data.get('show-blocked')) > -1;
  }

  set showingBlockedItems(showing) {
    this.data.set('show-blocked', showing ? '1' : false);
    this.hasToggleLinkTarget && (this.toggleLinkTarget.innerText = `${showing ? 'Hide' : 'Show'} blocked tasks`);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/tasks/task_activity_list_controller.js